module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "login-container"
  }, [_c('div', {
    staticClass: "text-center login-header mb-3"
  }, [_c('div', {
    staticClass: "brand"
  }, [_c('img', {
    staticStyle: {
      "width": "65px",
      "margin-bottom": "10px"
    },
    attrs: {
      "src": _vm.logo
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "white--text font-weight-400 mb-9",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("\n                Skolla Web Admin\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "login-content"
  }, [(this.hasError) ? _c('app-alert', {
    attrs: {
      "message": _vm.errorMessage,
      "isError": "true"
    },
    on: {
      "closed": function($event) {
        _vm.hasError = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "margin-bottom-0",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleLogin()
      }
    }
  }, [_c('div', {
    staticClass: "form-group m-b-20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control input-lg inverse-mode no-border",
    attrs: {
      "type": "text",
      "id": "login_email",
      "placeholder": "Masukan Alamat Email",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-b-20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control input-lg inverse-mode no-border",
    attrs: {
      "type": "password",
      "id": "login_password",
      "placeholder": "Masukan Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-buttons"
  }, [_c('v-btn', {
    staticClass: "mt-7",
    attrs: {
      "depressed": "",
      "block": "",
      "dark": "",
      "color": "blew",
      "large": "",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.handleLogin()
      }
    }
  }, [_vm._v("\n                        Login\n                    ")])], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "footer-login"
  }, [_vm._v("© 2023 Skolla. All Rights Reserved")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b037ab5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/auth/components/Login.vue
// module id = 1518
// module chunks = 1